import { isSharedIdentificationFeatureEnabled } from 'constant';
import { offer_step } from 'constant/static';

/**
 * Grubun kartı ortak mı. Ortaklaştırma kapatılınca kartlar maddelerde kaldığı için `identificationStatus` `shared`
 * kalır; tek başına okunmaz.
 */
export const isSharedIdentification = (group) =>
  group?.shareIdentification === true && group?.identificationStatus === 'shared';

/**
 * Kaydet gövdesine eklenecek ortaklaştırma alanı. Yalnız anahtarın son değeri grubun başlangıç değerinden farklıysa
 * gönderilir: BE zaten ortak bir grupta yeniden gelen `true`'yu baştan ortaklaştırma sayar ve ana maddenin kartını
 * bütün maddelere yeniden yazar. Gönderilmeyen alan BE'de olduğu gibi korunur.
 */
export const getShareIdentificationPayload = (shareIdentification, initialShareIdentification) => {
  if (!isSharedIdentificationFeatureEnabled || shareIdentification === initialShareIdentification) return {};

  return { shareIdentification };
};

/** Aşama statüden türetilmez; satırdaki `step` BE'nin grup detayından ya da madde aramasından gelir. */
export const isPostOrder = (member) => member.step >= offer_step.POST_ORDER;

/**
 * Ortaklaştırmanın neden açılamadığı; açılabiliyorsa `null`. Önce bütün maddelerin Telif Sonrası'nda olması aranır.
 * Ana maddenin kartı yalnız kayıtlı üyede (`memberId`) bilinir; yeni eklenen satırın kartını BE Kaydet'te kontrol eder.
 */
export const getShareIdentificationBlocker = (members, mainMember) => {
  const pendingMembers = members.filter((member) => !isPostOrder(member));
  if (pendingMembers.length > 0) return { pendingMembers };

  const hasCard = Boolean(mainMember?.identificationCard?.media?.length);
  if (mainMember?.memberId && !hasCard) return { mainMemberWithoutCard: mainMember };

  return null;
};
